const path = 'redux/campaign';
export const CAMPAIGNS_LOADED = `${path}/CAMPAIGNS_LOADED`;
export const CAMPAIGN_LOADED = `${path}/CAMPAIGN_LOADED`;
export const CAMPAIGN_MEMBERS_LOADED = `${path}/CAMPAIGN_MEMBERS_LOADED`;
export const DROPDOWN_VALUES_LOADED = `${path}/DROPDOWN_VALUES_LOADED`;
export const MEMBER_DICT_LOADED = `${path}/MEMBER_DICT_LOADED`;

